import styled from "styled-components";
export const SupplierAwaitingDeliveryStyle = styled.div``;
